module.exports = __webpack_public_path__ + "static/media/20240530075739_IMG_7388-min.3bbc13eb.JPG";